import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { useOperator } from "@/context/OperatorContext";
import { opApi, apiError } from "@/lib/api";

// "admin" (super admin, tagged) | "owner" (shown to owners) | "hidden"
export function useCartControls() {
  return useOperator()?.operator?.cart_controls || "hidden";
}

export function AdminOnlyTag() {
  return (
    <span className="ml-2 font-mono text-[10px] normal-case tracking-normal bg-[#FFBD2E] text-black px-1.5 py-0.5" data-testid="cart-controls-admin-tag">
      Super admin only
    </span>
  );
}

// Platform Control: one switch for every shop.
export function CartControlsSwitch() {
  const [state, setState] = useState(null);
  useEffect(() => { opApi.get("/admin/settings/cart-controls").then(({ data }) => setState(data)).catch(() => {}); }, []);
  if (!state) return null;

  const flip = async (v) => {
    try {
      const { data } = await opApi.put("/admin/settings/cart-controls", { owners_visible: v });
      setState(data);
      toast.success(v ? "Owners can now see Cart type & Add another cart" : "Hidden from owners");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div className="flex items-center justify-between gap-4 border border-border p-4 mb-4" data-testid="cart-controls-setting">
      <div>
        <div className="font-medium text-sm">Show Cart type &amp; Add another cart to owners</div>
        <div className="text-xs text-muted-foreground mt-0.5">
          {state.owners_visible ? "On: owners can see and change them." : "Off: only you can change them, in View as."} Applies to every shop.
          {state.updated_by && <> Last changed by {state.updated_by}{state.updated_at ? ` on ${new Date(state.updated_at).toLocaleString()}` : ""}.</>}
        </div>
      </div>
      <Switch checked={state.owners_visible} onCheckedChange={flip} data-testid="cart-controls-switch" />
    </div>
  );
}
